import { render, staticRenderFns } from "./Miniform.vue?vue&type=template&id=3fe5aa02"
import script from "./Miniform.vue?vue&type=script&lang=js"
export * from "./Miniform.vue?vue&type=script&lang=js"
import style0 from "./Miniform.vue?vue&type=style&index=0&id=3fe5aa02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports